export const mockData = [
  {
    id: "hanoi",
    name: "Hà Nội",
    province: [
      { id: "hoankiem", name: "Hoàn Kiếm" },
      { id: "haibatrung", name: "Hai Bà Trưng" },
      { id: "hoangmai", name: "Hoàng Mai" }
    ]
  },
  {
    id: "danang",
    name: "Đà Nẵng",
    province: [
      { id: "haichau", name: "Hải Châu" },
      { id: "camle", name: "Cẩm Lệ" },
      { id: "thanhkhe", name: "Thanh Khê" }
    ]
  },
  {
    id: "saigon",
    name: "Sài Gòn",
    province: [
      { id: "tanbinh", name: "Tân Bình" },
      { id: "tanphu", name: "Tân Phú" },
      { id: "phunhuan", name: "Phú Nhuận" }
    ]
  }
];
